// extracted by mini-css-extract-plugin
export default {"headerAndButtonsBox":"ClientHealth_headerAndButtonsBox__FwbNC","durationDropdown":"ClientHealth_durationDropdown__FOkWF"};